import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { getData } from "../../../utils/api";
import { ReplaceStatusIds, RoleId, Select2Data } from "../../../utils/common";
library.add(fas);

const ReplaceReason = (props) => {
  const { postData, user } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    control,
    formState: { errors },
  } = useForm();

  const [deliveryBoys, setDeliveryBoys] = useState([]);

  // const onSubmit = async (data) => {
  //   try {
  //     const finalData = new FormData();
  //     finalData.append("reason", data?.reason);
  //     finalData.append("order_status_id", 6);
  //     const response = await postData(
  //       `/admin/orders/replace-status/${props?.show}`,
  //       finalData
  //     );
  //     props.getDataAll();
  //     props.GetAllCounts();
  //     if (response?.success) {
  //       await setShowModal({ code: response.code, message: response.message });
  //     } else {
  //       await setShowModal({ code: response?.code, message: response?.errors });
  //     }
  //     setTimeout(() => {
  //       setShowModal(0);
  //       props.handleClose();
  //     }, 1000);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("reason", data?.reason);
      finalData.append("order_status_id", 6);

      const response = await postData(
        `/admin/orders/replace-status/${props?.show}`,
        finalData,
      );

      if (response?.success) {
        props.setReplaceStatusId(ReplaceStatusIds.ReplaceItemRejected);
        props.handleTabClick("ReplaceItemRejected");
        props.setonPageChange(1);

        await setShowModal({
          code: response.code,
          message: response.message,
        });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllDeliveryBoys = async () => {
    // if (user && user?.role_id === RoleId.Vendor) {
    const response = await getData(`/common/masters/delivery-boys`);
    if (response?.success) {
      setDeliveryBoys(await Select2Data(response?.data, "delivery_boy_id"));
    }
    // }
  };

  useEffect(() => {
    GetAllDeliveryBoys();
  }, [props.show]);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Rejected Reason
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Reason</Form.Label>
                    </div>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Reason"
                      className={classNames("", {
                        "is-invalid": errors?.reason,
                      })}
                      {...register("reason", {
                        required: "reason is required",
                        validate: (value) =>
                          value.length <= 200 ||
                          "Data must be 200 characters or less",
                      })}
                    />
                    {errors.reason && (
                      <span className="text-danger">
                        {errors.reason.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"Cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"Reject"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ReplaceReason;
